import { Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
import { MatTab, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
declare var bootstrap: any;
@Component({
  selector: 'app-customers',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
    RouterLink,
    MatTabsModule
  ],
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss'
})
export class CustomersComponent {
  startpoint: number;
  search: any;
  totalLoaded: number;
  total: any;
  pageNo: any;
  pageSize: any
  companySelectOptions: any[] = [];

  constructor(
    private companyService: CompanyService,
    private userService: UserServiceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService,
    public activatedRoute: ActivatedRoute,
  ) {
    this.setDisplayedColumns();
  }


  isCompanyLoggedIn: boolean = false

  getCompanyData() {
    let userData = this.userDataService.getData()
    let companyData = userData.company
    if (!!companyData) {
      this.isCompanyLoggedIn = true
      this.filter.companyId = companyData._id
      this.getAllCustomers(null)
    }
    else {
      this.isCompanyLoggedIn = false
      this.getAllCustomers(null);
    }
  }

  isTodayCust: any = false;

  ngOnInit(): void {
    this.isTodayCust = this.activatedRoute.snapshot.queryParamMap.get("isTodayCust");
    if (this.isTodayCust === 'true') {
      const today = new Date();
      this.filter.startdate = today;
      this.filter.enddate = today;
    }

    this.getCompanyData()
    if (this.isCompanyLoggedIn === false) {
      this.displayedColumns.splice(2, 0, 'email');
      this.displayedColumns.splice(3, 0, 'phone');
    }
    this.allCompaniesMini()
  }

  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath
  }

  displayedColumns: string[] = [];



  setDisplayedColumns(): void {
    this.displayedColumns = [
      'position', 'name', 'gender', 'dob', 'state', 'city', 'address','sampleCount', 'createdAt', 'samples'
    ];
  }


  @ViewChild(MatPaginator) paginator: MatPaginator;



  calculateAge(dob: string | Date): number {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }


  debounceNameTimer: any = null;
  debounceCityStateTimer: any = null;

  filter: any = {
    name: '',
    cityState: '',
    companyId: null,
    customerSelection: 0,
    startdate: null,
    enddate: null,
  };

  allCompanies: any[] = [];


  companyFilter(event: any): void {
    this.getAllCustomers(null);
  }


  allCompaniesMini() {
    this.companyService.allCompaniesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCompanies = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }


  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value.trim();
      this.filter.name = name || undefined;
      this.getAllCustomers(null);
    }, 500);
  }


  onCityStateChange(event: any): void {
    clearTimeout(this.debounceCityStateTimer);
    this.debounceCityStateTimer = setTimeout(() => {
      const cityState = event.target.value.trim();
      this.filter.cityState = cityState || undefined;
      this.getAllCustomers(null);
    }, 500);

  }
  clearDateRange(): void {
    this.filter.startdate = null;
    this.filter.enddate = null;
    this.getAllCustomers(null);
  }
  dataSource = new MatTableDataSource<any>([]);


  customersSelection = [
    { label: 'All Customers', value: 0 },
    { label: 'Company Sample Holders', value: 1 }
  ];


  getAllCustomers(event: any) {
    this.spinner.show();
    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || 10;
      this.dataSource.data = [];
    }

    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
    }

    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || 10);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize,
      search: this.search || undefined,
      nameEmail: this.filter?.name || undefined,
      cityState: this.filter?.cityState || undefined,
      companyId: this.filter?.companyId || undefined,
      startdate: this.filter.startdate || undefined,
      enddate: this.filter.enddate || undefined
    };

    let apiCall: any;


    if (this.isCompanyLoggedIn) {
      apiCall = this.userService.getAllCUSTOMERS(data);
    } else {
      if (this.filter.customerSelection === 0) {
        apiCall = this.userService.getAllRegisteredCustomers(data);
      } else {
        apiCall = this.userService.getAllCUSTOMERS(data);
      }
    }


    apiCall.subscribe({
      next: (result) => {
        if (result?.success) {
          this.spinner.hide();
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];

          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize;
            }
          }, 0);
        } else {
          this.spinner.hide();
          this.toastr.error(result.message || "Failed to fetch customers");
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        let errorMsg = "An unexpected error occurred.";
        if (error.status === 0) {
          errorMsg = "Server not reachable. Please check your network connection.";
        } else if (error.error?.message) {
          errorMsg = error.error.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        this.toastr.error(errorMsg, "Error");
        console.error("Customer Fetch Error:", error);
      },
      complete: () => this.spinner.hide()
    });
  }




  getFullAddress(element: any): string {
    let fullAddress = '';
    if (element?.address) {
      fullAddress += element.address;
    }
    if (element?.city) {
      if (fullAddress) fullAddress += ', ';
      fullAddress += element.city;
    }
    if (element?.state) {
      if (fullAddress) fullAddress += ', ';
      fullAddress += element.state;
    }
    return fullAddress;
  }
  getPartialAddress(element: any): string {
    const fullAddress = this.getFullAddress(element);
    const words = fullAddress.split(' ');
    let shortAddress = words.slice(0, 4).join(' ');
    if (words.length > 4) {
      shortAddress += '...';
    }
    return shortAddress;
  }




}
